import { Card, CardContent, Typography, Box } from '@mui/material'
import { COMMERCIAL_CARD_STYLES } from '../../constants/ClientDashboardConst'

export default function CommercialCard({
  title,
  value,
  icon,
  iconBg = COMMERCIAL_CARD_STYLES.iconBg
}) {
  return (
    <Card
      elevation={4}
      sx={{
        borderRadius: 2,
        height: 126,
        width: 275,
        border: '3px solid #E4E4E4',
        boxShadow: 0
      }}
    >
      <CardContent
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            minHeight: 44
          }}
        >
          <Typography
            sx={{
              fontSize: 16,
              fontWeight: 700,
              letterSpacing: 0.5
            }}
          >
            {title}
          </Typography>

          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: 3,
              backgroundColor: iconBg,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }}
          >
            {icon}
          </Box>
        </Box>

        <Typography
          sx={{
            fontSize: 32,
            fontWeight: 900,
            color: COMMERCIAL_CARD_STYLES.valueColor,
            mt: 1
          }}
        >
          {value}
        </Typography>
      </CardContent>
    </Card>
  )
}
